// extracted by mini-css-extract-plugin
export default {"errorWrapper":"Error_errorWrapper__QuwG9","error":"Error_error__asHfx"};